<template>
  <v-stepper v-model="step" elevation="0">
    <v-stepper-header class="elevation-1">
      <template v-for="(item, i) in steps">
        <v-stepper-step
          :key="item.title + 'header' + i"
          :complete="step > i + 1"
          :step="i + 1"
          :color="item.color ? item.color : 'primary'"
        >
          {{ item.title }}
          <small v-if="item.subtitle">
            {{ item.subtitle }}
          </small>
        </v-stepper-step>
        <v-divider v-if="i < steps.length - 1" :key="i + 'divider'" />
      </template>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content
        v-for="(item, i) in steps"
        :key="item.title + 'content' + i"
        :step="i + 1"
      >
        <v-card v-if="i + 1 == step" flat>
          <v-card-text>
            <component
              :is="step_obj.component"
              v-bind="step_obj.props"
              @loading-start="
                (msg) => {
                  isLoading = true;
                  text = msg;
                }
              "
              @loading-stop="isLoading = false"
              @cant-continue="(e) => (nextDisabled = e)"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="changeStep(i)"
              color="primary"
              v-if="step > 1 && step != length"
              class="move-btn"
            >
              <v-icon> mdi-arrow-left-bold </v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              @click="changeStep(i + 2)"
              v-if="i + 1 < length"
              color="primary"
              class="move-btn"
              :disabled="nextDisabled"
            >
              <v-icon> mdi-arrow-right-bold </v-icon>
            </v-btn>
            <v-btn
              v-if="i + 1 == length"
              block
              color="primary"
              height="50px"
              @click="backToBeggining()"
            >
              В начало
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
    <v-overlay
      v-model="isLoading"
      class="text--center d-flex flex-column justify-center"
    >
      <v-progress-circular
        indeterminate
        width="10"
        size="100"
        color="primary"
        class="mr-5"
      />
      {{ text }}
    </v-overlay>
  </v-stepper>
</template>

<script>
export default {
  data() {
    return {
      step: 1,
      length: this.steps.length,
      isLoading: false,
      nextDisabled: false,
      text: "Загрузка",
    };
  },
  props: {
    steps: Array,
  },
  computed: {
    step_obj() {
      return this.steps[this.step - 1];
    },
  },
  methods: {
    changeStep(i) {
      this.step = i;
    },
    backToBeggining() {
      this.$store.dispatch("clearUpload");
      this.step = 1;
    },
  },
};
</script>

<style scoped>
.move-btn {
  width: 130px !important;
  height: 50px !important;
}
</style>